export default "__VITE_ASSET__l7Z9sCv$__"